export enum StoreThemeEnum {
  light = 'light',
  dark = 'dark',
}
